import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "product-images" };
const _hoisted_2 = { class: "product-images__image" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
    key: 1,
    class: "product-images__none"
};
const _hoisted_5 = {
    key: 0,
    class: "product-images__thumbs"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src", "alt"];
import { computed, onMounted, ref, watch } from 'vue';
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductImages',
    props: {
        images: {}
    },
    setup(__props) {
        const props = __props;
        const selected = ref(null);
        const selectedSource = computed(() => {
            if (!selected.value) {
                return null;
            }
            return source(selected.value, config.productImages.sizes.default);
        });
        onMounted(selectFirstImage);
        watch(() => props.images, selectFirstImage);
        function selectFirstImage() {
            if (props.images.length > 0) {
                selectImage(props.images[0]);
            }
            else {
                selected.value = null;
            }
        }
        function selectImage(image) {
            selected.value = image;
        }
        function source(image, size) {
            const thumb = image.sources.find(s => s.size === size);
            return (thumb && thumb.url) || 'TODO not found URL';
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (selectedSource.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: selectedSource.value,
                            alt: selected.value?.title
                        }, null, 8, _hoisted_3))
                        : _createCommentVNode("", true),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    (__props.images.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_icon, { name: "image" })
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (__props.images.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (img, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                onClick: _withModifiers(($event) => (selectImage(img)), ["prevent"]),
                                class: _normalizeClass(["product-images__thumb", { 'product-images__thumb--active': selected.value === img }])
                            }, [
                                _createElementVNode("img", {
                                    src: source(img, _unref(config).productImages.sizes.thumbnail),
                                    alt: img.title
                                }, null, 8, _hoisted_7)
                            ], 10, _hoisted_6));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
